import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

import Page from '@/components/Page/index.ts';
import type { CompetitionWinner } from '@/lib/api/requests.ts';

import CalendarCompetition from './_components/CalendarCompetition/index.ts';
import EndOfCompetition from './_components/EndOfCompetition/index.ts';

const MainContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  background: theme.palette.background.default,
  [theme.breakpoints.up('lg')]: {
    paddingBlock: theme.spacing(2),
    background: theme.palette.background.paper,
    alignItems: 'center',
  },
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    background: theme.palette.background.paper,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

interface CalendarContainersProps {
  winners: CompetitionWinner[];
  meta: unknown;
}

const CalendarContainers = ({ winners, meta }: CalendarContainersProps) => {
  return (
    <Page title="Julekalender">
      <MainContainer>
        <StyledContainer maxWidth="xl">
          <div className="flex w-full flex-col items-stretch gap-4 lg:flex-row">
            <div
              className="flex flex-col items-center overflow-hidden rounded-none px-6 pb-6 sm:pt-4 lg:w-5/12 lg:rounded-[20px]"
              style={{ backgroundColor: '#12453F' }}
            >
              <EndOfCompetition meta={meta} />
            </div>
            <div className="flex flex-col justify-center lg:w-7/12">
              <CalendarCompetition winners={winners} />
            </div>
          </div>
        </StyledContainer>
      </MainContainer>
    </Page>
  );
};

export default CalendarContainers;
